export default "__VITE_ASSET__c1435743__"